import { useEffect } from "react"
import { GlobalMachineContext } from "../../../study-plans/pages/StudyPlansInit/StudyPlansInit"
import { useFilterStateContext } from "../../../../reporting/providers/FiltersStateProvider"

export const useSPV2FiltersSync = () => {
  const { state: filtersState } = useFilterStateContext() ?? {
    state: undefined,
    setState: undefined
  }
  const { program, subject, isStudyPlanV2Enabled } =
    GlobalMachineContext.useSelector(state => ({
      program: state.context.program,
      subject: state.context.subject,
      isStudyPlanV2Enabled: state.context.isStudyPlanV2Enabled
    }))
  const { send } = GlobalMachineContext.useActorRef()

  const [filterProgram, filterSubject] =
    filtersState?.test?.[0]?.split("_") ?? []

  useEffect(() => {
    if (isStudyPlanV2Enabled) {
      send({
        type: "UPDATE_REPORTING_FILTERS_STATE",
        state: filtersState
      })
    }
  }, [filtersState, isStudyPlanV2Enabled])

  useEffect(() => {
    if (!isStudyPlanV2Enabled) {
      return
    }

    if (filterProgram !== program) {
      send({
        type: "CHANGE_PROGRAM",
        program: filterProgram,
        subject: filterSubject
      })

      return
    }

    if (filterSubject !== subject) {
      send({
        type: "SELECT_SUBJECT",
        newSubject: filterSubject
      })
    }
  }, [program, subject, filterProgram, filterSubject, isStudyPlanV2Enabled])
}
